import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  changePersonalityAnswer,
  getPersonalityQuestion,
  getPersonality,
  finishPersonality,
} from '../../../../ducks/respondent'
import styles from './PersonalityQuestion.module.scss'
import { Tile } from 'components/shared/Tile/Tile'
import SwipePage, { Slider } from 'components/common/SwipePage'
import {
  nextPage,
  previousPage,
  nextUnanswered,
  getQuizPage,
  getLocation,
} from 'ducks/router'
import { QuestionContainer } from 'components/shared/QuestionContainer/QuestionContainer'

const selectQuestion = state => {
  // `answered` reads the first question, not the current one
  const { value } = getPersonalityQuestion({ page: undefined })(state)
  const { totalQuestions, totalAnswers } = getPersonality(state)
  const finished = totalQuestions - totalAnswers === 0
  const pageFromUrl = Number(getLocation(state).payload.page)

  return {
    questions: state.respondent.personality.questions,
    finished,
    totalQuestions,
    totalAnswers,
    pageFromUrl,
    answered: value !== null,
    reversed: getQuizPage(state).reversed,
    ...getPersonalityQuestion(null)(state),
  }
}

const PersonalityQuestion = () => {
  const {
    question,
    finished,
    totalQuestions,
    pageFromUrl,
    answered,
    questions,
    prompt,
    instrument,
    label = 'which number?',
    scale = { 1: 'one', 2: 'two', 3: 'three' },
    value = null,
    reversed,
  } = useSelector(selectQuestion, shallowEqual)
  const dispatch = useDispatch()

  const changeValue = value => {
    dispatch(changePersonalityAnswer({ instrument, key: question, value }))
    value && dispatch(nextUnanswered())
  }

  // no page in the URL, as after leaving the test: there is no question to show
  if (!questions || Number.isNaN(pageFromUrl)) {
    return null
  }

  const questionIndex = pageFromUrl + 1

  const tiles = Object.entries(scale).map(([val, label]) => (
    <Tile
      key={val}
      label={label}
      onClick={ev => {
        ev.preventDefault()
        ev.stopPropagation()
        changeValue(val === String(value) ? null : val)
      }}
      selected={val === value}
    />
  ))

  return (
    <QuestionContainer
      {...{
        questionIndex,
        totalQuestions,
        finished,
        answered,
      }}
      previousPage={() => dispatch(previousPage())}
      nextUnanswered={() => dispatch(nextUnanswered())}
      nextPage={() => dispatch(nextPage())}
      finishTest={() => dispatch(finishPersonality())}
      collapse
    >
      <Slider page={prompt} reversed={reversed} slideSpeed={400}>
        <div className={styles.prompt}>{prompt}</div>
      </Slider>

      <SwipePage slideSpeed={400}>
        <div className={styles.swipePage}>
          <div className={styles.statement}>{label}</div>
          <div className={styles.tiles}>{tiles}</div>
        </div>
      </SwipePage>
    </QuestionContainer>
  )
}

export default PersonalityQuestion
